import React from "react";
import CrudPage from "@/components/common/CrudPage";
import { GanttChart } from "lucide-react";

const FIELDS = [
  { k: "type", label: "Τύπος (Σύλληψη/Απολογία/Παραπεμπτικό/Προθεσμία/Έφεση)" },
  { k: "title", label: "Τίτλος" },
  { k: "date", label: "Ημερομηνία", type: "date" },
  { k: "description", label: "Περιγραφή", type: "textarea", rows: 4 },
  { k: "deadline", label: "Προθεσμία (αν υπάρχει)", type: "date" },
];

export default function Procedure() {
  return (
    <CrudPage
      slug="procedure" title="Δικονομική Πορεία"
      subtitle="Δικονομικό ιστορικό, εντάλματα, αποφάσεις, προθεσμίες και λόγοι έφεσης."
      emptyIcon={GanttChart} fields={FIELDS}
      listColumns={{
        title: it => it.title || it.type,
        subtitle: it => `${it.type || "—"} · ${it.date ? new Date(it.date).toLocaleDateString("el-GR") : "—"}`,
        body: it => it.description,
      }}
      badges={{}}
    />
  );
}
